/**
 * Generates a CSV string from a 2d array.
 *
 * @param dataRows - 2d array of table data rows
 * @returns - csv string
 */
export function convertArrayToCsv(dataRows: string[][]): string {
  const lines: string[] = Array.from({ length: dataRows.length });
  for (let i = 0; i < dataRows.length; i++) {
    lines[i] = dataRows[i].join(',');
  }
  return lines.join('\n') + '\n';
}
